import { ActivityModel } from 'api-hooks/activity';
import React from 'react';

import { ActivityFormType } from '../components/form-type';

export default function useActivityDefaultValues(activity?: ActivityModel) {
  const defaultValues = React.useMemo<ActivityFormType>(() => {
    return {
      code: activity?.code || '',
      name: activity?.name || '',
      description: activity?.description || '',
      type: activity?.type || '',
      email: activity?.email || '',
      phone: activity?.phone || '',
      phone_2: activity?.phone_2 || '',
    };
  }, [activity]);

  return defaultValues;
}
